/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: file-system-properties-component.ts
 *
 * Created by kyang on 2020-09-11.
 */

function FileSystemPropertiesController (
    this: JS5Object,
    $location: JS5Object,
    $q: JS5Object,
    $route: JS5Object,
    $routeParams: JS5Object,
    FileSystemService: JS5Object,
    FileSystemEditService: JS5Object,
    SidebarService: JS5Object,
) {

    this.editingNewFileSystem = () => {
        return $routeParams.id === '-1';
    };

    //=========//
    // Toolbar //
    //=========//

    const saveEditData = () => {
        let savePromise: JS5Promise;
        this.loadingIndicator.show = true;
        if (this.editingNewFileSystem()) {
            savePromise = FileSystemService.createFileSystem(this.fileSystemObject);
        } else {
            savePromise = FileSystemService.updateFileSystem(this.fileSystemObject);
        }
        savePromise.then((fileSystem: JS5Object) => {
            FileSystemEditService.setOriginalEditData(fileSystem);
            this.fileSystemObject = fileSystem;
            $route.updateParams({id: fileSystem.id});
        })
            .finally(() => {
                this.loadingIndicator.show = false;
            });
    };

    const revertEditData = () => {
        this.fileSystemObject = _.cloneDeep(FileSystemEditService.originalEditData);
        this.editorForm.$setPristine();
        if (this.editingNewFileSystem()) {
            exitEdit();
        }
    };

    const exitEdit = () => {
        $location.url('/system/fileSystems/search');
    };

    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: () => !this.editorForm.$pristine && this.editorForm.$valid,
            onClick: saveEditData
        }, {
            label: 'Revert',
            enabled: () => !this.editorForm.$pristine || this.editingNewFileSystem(),
            onClick: revertEditData
        }, {
            label: 'Close',
            enabled: () => this.editorForm.$pristine && !this.editingNewFileSystem(),
            onClick: exitEdit
        }
    ];


    //=================//
    // Lifecycle Hooks //
    //=================//

    const getData = () => {
        let promises = [];
        this.loadingIndicator.show = true;
        promises.push(FileSystemService.getFileSystemTypes()
            .then((fileSystemTypes: JS5Object[]) => {
                this.fileSystemTypes = fileSystemTypes;
            }));

        if (this.editingNewFileSystem()) {
            this.fileSystemObject = _.get(this, 'fileSystemObject', {});
            FileSystemEditService.setOriginalEditData(this.fileSystemObject);
        } else {
            promises.push(FileSystemService.getFileSystem($routeParams.id)
                .then((fileSystem: JS5Object) => {
                    FileSystemEditService.setOriginalEditData(fileSystem);
                    this.fileSystemObject = fileSystem;
                }));
        }
        $q.all(promises).finally(() => {
            this.loadingIndicator.show = false;
        });
    };

    this.$onInit = () => {
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        getData();
    };

    this.$postLink = () => {
        FileSystemEditService.editorForm = this.editorForm;
        SidebarService.editService = FileSystemEditService;
    };

    this.$onDestroy = () => {
        FileSystemEditService.editorForm = null;
    };
}

angular.module('prism-ui.fileSystem').component('fileSystemPropertiesView', {
    templateUrl: 'system/fileSystem/editView/properties/file-system-properties-template.html',
    controller: FileSystemPropertiesController
});
